import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Box,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
  import MenuIcon from "@mui/icons-material/Menu";
  import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
  import Inventory2Icon from "@mui/icons-material/Inventory2";
  import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
  import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
  import LocalCafeIcon from "@mui/icons-material/LocalCafe";
  import GroupsIcon from "@mui/icons-material/Groups";
  import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
  import TvIcon from "@mui/icons-material/Tv";
  import ForumIcon from "@mui/icons-material/Forum";
  import AssessmentIcon from "@mui/icons-material/Assessment";
  import LogoutIcon from "@mui/icons-material/Logout";

  import { useNavigate } from "react-router-dom";
  import { useAuth } from "../../Context/AuthContext";
  import { ADMIN_ACCESS, getAdminRoleAccess } from "../../access/adminAccess";

  export default function Sidebar({ drawerWidth, collapsedWidth = 64, open = true, onToggle, anchor = "left" }) {
    const navigate = useNavigate();
    const { logout, userRole } = useAuth();

    // ربط label بالأيقونة المناسبة
    const iconMap = {
      "لوحة التحكم": <MenuIcon />,
      "المنيو": <RestaurantMenuIcon />,
      "الخامات": <Inventory2Icon />,
      "الطاولات": <TableRestaurantIcon />,
      "الفواتير": <ReceiptLongIcon />,
      "مشروبات AI": <LocalCafeIcon />,
      "بيانات العملاء": <GroupsIcon />,
      "المستخدمين": <ManageAccountsIcon />,
      "شاشات": <TvIcon />,
      "تقارير محادثات agent": <ForumIcon />,
      "احصائيات استهلاك الخامات": <AssessmentIcon />,
      "نقطة البيع": <ReceiptLongIcon />,
      "استخدام المواد": <AssessmentIcon />,
      "تقارير الطلبات": <ReceiptLongIcon />,
    };

    // جلب قائمة الصفحات المسموحة لهذا الدور
    const menuItems = getAdminRoleAccess(userRole)?.menu || [];

    const width = open ? drawerWidth : collapsedWidth;

    return (
    <Drawer
      anchor={anchor}
      variant="permanent"
      sx={{
        width: width,
        flexShrink: 0,
        position: "fixed",
        top: 0,
        bottom: 0,
        ...(anchor === "left" ? { left: 0 } : { right: 0 }),
        zIndex: (theme) => theme.zIndex.drawer,
        "& .MuiDrawer-paper": {
          width: width,
          boxSizing: "border-box",
          bgcolor: "primary.main",
          color: "#fff",
          overflowX: "hidden",
          position: "fixed",
          top: 0,
          bottom: 0,
          ...(anchor === "left" ? { left: 0 } : { right: 0 }),
        },
      }}
    >
        <Toolbar sx={{ display: "flex", justifyContent: open ? "space-between" : "center", alignItems: "center" }}>
          {open && (
            <Typography variant="h6" fontWeight="bold">
              Admin Panel
            </Typography>
          )}

          <Tooltip title="Toggle sidebar">
            <IconButton onClick={onToggle} sx={{ color: "#fff" }} aria-label="toggle sidebar">
              <MenuIcon />
            </IconButton>
          </Tooltip>
        </Toolbar>

        <Box sx={{ overflow: "auto" }}>
          <List>
            {menuItems.map((item, index) => (
              <ListItemButton
                key={index}
                onClick={() => navigate(item.path)}
                sx={{
                  "&:hover": { bgcolor: "primary.dark" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ListItemIcon sx={{ color: "#fff", minWidth: 0, mr: open ? 2 : 0, justifyContent: "center" }}>
                  {iconMap[item.label] || <MenuIcon />}
                </ListItemIcon>
                {open && <ListItemText primary={item.label} />}
              </ListItemButton>
            ))}

            <ListItemButton
              onClick={() => {
                logout();
                navigate("/background/gate/login");
              }}
              sx={{ "&:hover": { bgcolor: "primary.dark" } }}
            >
              <ListItemIcon sx={{ color: "#fff", minWidth: 0, mr: open ? 2 : 0, justifyContent: "center" }}>
                <LogoutIcon />
              </ListItemIcon>
              {open && <ListItemText primary="Logout" />}
            </ListItemButton>
          </List>
        </Box>
      </Drawer>
    );
  }
